// @flow
import AssignServiceAvailableOperatorsModalContainer from './AssignServiceAvailableOperatorsModalContainer';
import type { Operator, Service } from './AssignServiceAvailableOperatorsModal';

export default AssignServiceAvailableOperatorsModalContainer;
export type { Operator, Service };
